import { ListPreferenceResult, setListPreference } from '../../utils/list/utils/setListPreference';
import { Preferences } from '../../profile/objects/preferences';
import { DEFAULT_COLUMN, PURCHASE_MODULE } from '../constant/purchaseConstant';
import { Column } from '../objects/column';

export const setPurchasePreference = (
    new_preferences: Preferences[],
    state_columns: Column[],
): ListPreferenceResult => setListPreference(new_preferences, state_columns, {
    module: PURCHASE_MODULE,
    default_columns: DEFAULT_COLUMN,
    default_order_by: '-created_date',
    default_order: 'asc',
});
